var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"title":_vm.hint,"variant":_vm.enabled?'primary':'primary-outlined'},on:{"click":function($event){return _vm.$emit('click')}}},[_c('b-icon',{attrs:{"icon":_vm.iconName}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }